export default __webpack_public_path__ + "static/media/Enero2024(768x800).e62d4ca0.webp";